import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/umbrella.vue
var s = {
	name: "DtIconUmbrella",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--umbrella"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Umbrella",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M9.714 2.423a5.461 5.461 0 0 1 1.784 3.528A.5.5 0 0 1 11 6.5H6.5V10a.5.5 0 0 0 1 0 .5.5 0 0 1 1 0 1.5 1.5 0 0 1-3 0V6.5H1a.5.5 0 0 1-.498-.549 5.461 5.461 0 0 1 1.784-3.528 5.56 5.56 0 0 1 3.198-1.398L5.486.97a.509.509 0 1 1 1.018 0v.053a5.56 5.56 0 0 1 3.21 1.4ZM1.586 5.5a4.46 4.46 0 0 1 1.368-2.333 4.56 4.56 0 0 1 6.092 0A4.46 4.46 0 0 1 10.414 5.5H1.586Z",
		fill: "currentColor"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=umbrella.js.map